import { AdminDashboardPage } from "../pages/AdminDashboardPage";
import { HospitalDashboardPage } from "../pages/HospitalDashboardPage";
import { DoctorDashboardPage } from "../pages/DoctorDashboardPage";
import { AuthProvider, RequireAdminAuth, useAuth } from "../hooks/AuthContext";

const DashboardRouter = () => {
  const { user, isHospitalAdmin, isDoctorAdmin } = useAuth();

  if (user?.doctor_id || isDoctorAdmin) {
    return <DoctorDashboardPage />;
  }
  if (isHospitalAdmin) {
    return <HospitalDashboardPage />;
  }
  return <AdminDashboardPage />;
};

export { AdminDashboardPage, AuthDataPage } from "../pages/AdminDashboardPage";
export { HospitalDashboardPage } from "../pages/HospitalDashboardPage";
export { DoctorDashboardPage } from "../pages/DoctorDashboardPage";

export const AdminDashboard = () => (
  <AuthProvider>
    <RequireAdminAuth>
      <DashboardRouter />
    </RequireAdminAuth>
  </AuthProvider>
);
